import * as moment from 'moment';

export class Ide {
    numeracion: string;
    fechaEmision: string;
    codTipoDocumento: string;
    tipoMoneda: string;
    numeroOrdenCompra: string;
    fechaVencimiento: string;
    formaPago: string;
    notasCaso: string;
    montoNetoPendientePago: string;

    constructor(numeracion: string = '',
                fechaEmision?: string,
                codTipoDocumento: string = '01',
                tipoMoneda: string = 'PEN',
                numeroOrdenCompra: string = null,
                fechaVencimiento: string = null,
                formaPago: string = 'Contado',
                notasCaso?: string,
                montoNetoPendientePago: string = '',
    ) {
        this.numeracion = numeracion;
        this.fechaEmision = moment(new Date()).format('YYYY-MM-DD');
        this.codTipoDocumento = codTipoDocumento;
        this.tipoMoneda = tipoMoneda;
        this.numeroOrdenCompra = numeroOrdenCompra;
        this.fechaVencimiento = fechaVencimiento;
        this.formaPago = formaPago;
        this.notasCaso = notasCaso;
        this.montoNetoPendientePago = montoNetoPendientePago;
    }
}




// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/emisorFacturas/recursos/modelo/ide.ts